import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  constructor(
    private readonly languageService: LanguageService,
    private readonly authService: AuthService,
  ) {}

  async initApp(): Promise<any> {
    try {
      const isAuthenticated = await this.authService.isAuthenticated();

      return isAuthenticated ? this.fetchDataForAuthUser() : undefined;
    } catch {
      return undefined;
    }
  }

  private async fetchDataForAuthUser(): Promise<any> {
    await this.languageService.fetchPrimaryLanguage();
  }
}
